import { Component, AfterViewInit, Input, Output, EventEmitter } from '@angular/core';
import { FormArray } from '@angular/forms';
import { FormConstants } from '../../../core/globals/form-constants';

@Component({
    selector: 'app-stepper',
    templateUrl: './stepper.component.html',
    styleUrls: ['./stepper.component.scss']
})

export class StepperComponent implements AfterViewInit {
  @Input() steps: any[];
  @Input() activeStep: number;
  @Input() hideStepNumber: boolean;
  @Input() formArray: FormArray;
  @Input() centerText: boolean;
  @Input() activeBlue = false;
  @Input() line = true;
  @Input() openForm = '';

  public formError = FormConstants.errorMessages.formError;

  @Output() stepChangeCallback = new EventEmitter();

  ngAfterViewInit() {
    // settimeout added to fix ExpressionChangedAfterItHasBeenCheckedError
    setTimeout(() => {
      if (this.steps && this.steps.length && !this.activeStep) {
        this.activeStep = 0;
        this.stepChangeCallback.emit(0);
      }
    }, 0);
  }

  stepClick(stepIndex: number): void {
    if (stepIndex !== this.activeStep) {
      this.stepChangeCallback.emit(stepIndex);
    }
  }

  hasError(index: number) {
    if (this.formArray) {
      const formGroup = this.formArray.at(index);
      return Boolean(formGroup && formGroup.invalid && formGroup.dirty);
    }
    return false;
  }
}
